import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import { copyCustomReport } from '../../service/customReportService'
import customReportQueryKeys from '../customReportQueryKeys'
import formulaQueryKeys from '../../../formulas/queries/formulaQueryKeys'

const useCtxCopyCustomReport = () => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (reportId: number | string) => copyCustomReport(reportId, companyId),
    onSuccess: () => {
      notification.success({
        message: t('messages:createSuccess')
      })
      queryClient.invalidateQueries({
        queryKey: formulaQueryKeys.list({ companyId })
      })
      return queryClient.invalidateQueries({
        queryKey: customReportQueryKeys.list(companyId)
      })
    },
    onError: () => {
      notification.error({ message: t('messages:actionError') })
    }
  })
}

export default useCtxCopyCustomReport
